import MessageService from '../../../modules/message/messageService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'MESSAGE_FORM'

const messageFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: messageFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await MessageService.find(id)
      }

      dispatch({
        type: messageFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: messageFormActions.INIT_ERROR,
      })

      dispatch(push('/message'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: messageFormActions.CREATE_STARTED,
      })

      await MessageService.create(values)

      dispatch({
        type: messageFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.message.create.success'),
      )

      dispatch(push('/message'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: messageFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: messageFormActions.UPDATE_STARTED,
      })

      await MessageService.update(id, values)

      dispatch({
        type: messageFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.message.update.success'),
      )

      dispatch(push('/message'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: messageFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default messageFormActions
